import { EMRdetailsProps, IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useForm } from "react-hook-form";

const ReasonForVisitComponent = ({ emrDetails }: EMRdetailsProps) => {
  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();
  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");
  const isFirstLoad = useRef(true);

  const formHook = useForm<{ reason_for_visit: string }>({ mode: "onChange" });

  const debouncedUpdate = useMemo(
    () =>
      debounce((value: string) => {
        const body: IEMRUpdatePayloadProps = {
          reason_for_visit: value,
          emr_status: emrDetails?.emr_status,
        };
        updateEmrAPI(emr_id, body);
      }, 500),
    [emr_id, emrDetails?.emr_status, updateEmrAPI],
  );

  useEffect(() => {
    if (emrDetails) {
      isFirstLoad.current = true;
      formHook.reset({ reason_for_visit: emrDetails?.reason_for_visit || "" });
      setTimeout(() => { isFirstLoad.current = false; }, 0);
    }
  }, [emrDetails]);

  const handleChange = useCallback(() => {
    debouncedUpdate(formHook.getValues("reason_for_visit"));
  }, [formHook, debouncedUpdate]);

  useEffect(() => () => { debouncedUpdate.cancel(); }, [debouncedUpdate]);

  return (
    <div className="w-full py-3 bg-white p-3 rounded-[10px] mt-3">
      <h3 className="text-[#656565] text-sm font-medium tracking-tight42 px-2">Reason for Visit</h3>
      <div className="bg-[#F9FAFB] w-full rounded-xl p-2 mt-2">
        <textarea
          className="w-full border border-[#E2E2E2] rounded-xl p-3 text-sm text-[#6C727F] focus:outline-none"
          placeholder="Main presenting complaint or purpose of the visit..."
          rows={2}
          {...formHook.register("reason_for_visit", {
            required: false,
            onChange: handleChange,
          })}
        />
      </div>
    </div>
  );
};

export default ReasonForVisitComponent;
